import {Repository} from '@s-ui/domain'

/**
 * @interface
 */
export default class SmartbannerRepository extends Repository {
  /**
   * @method
   * @return {Error}
   */
  getSmartbanner() {
    throw new Error('[SmartbannerRepository#getSmartbanner] must be implemented')
  }
}
